import { Flex } from "@redotech/arbiter/flex";
import { RedoModal } from "@redotech/arbiter/modal/redo-modal";
import { Text } from "@redotech/arbiter/text";
import BarChartIcon from "@redotech/redo-icons/bar-chart-01.svg";
import { memo } from "react";
import { OrderCountsModalData } from "./use-handle-schedule-demo";

interface OrderCountsModalProps {
  data: OrderCountsModalData;
  onClose: () => void;
}

export const OrderCountsModal = memo(function OrderCountsModal({
  data,
  onClose,
}: OrderCountsModalProps) {
  return (
    <RedoModal
      isOpen
      onModalCloseRequested={onClose}
      primaryButton={{ text: "Close", onClick: onClose }}
      title="Order counts"
      TitleIcon={BarChartIcon}
    >
      <Flex dir="column" gap="xl">
        <Flex dir="column" gap="xs">
          <Text fontSize="sm" fontWeight="medium" textColor="secondary">
            Last 30 days
          </Text>
          <Text fontSize="lg" fontWeight="semibold">
            {data.lastThirtyDaysCount.toLocaleString()}
          </Text>
        </Flex>
        <Flex dir="column" gap="xs">
          <Text fontSize="sm" fontWeight="medium" textColor="secondary">
            Last year
          </Text>
          <Text fontSize="lg" fontWeight="semibold">
            {data.lastYearCount.toLocaleString()}
          </Text>
        </Flex>
      </Flex>
    </RedoModal>
  );
});
